export const APP_STATUS_APPROVED = 'APPROVED'
export const APP_STATUS_PENDING = 'PENDING'
export const APP_STATUS_REJECTED = 'NOT_APPROVED'

// manager roles as defined in Auth0
export const roles = {
    manager: 'App Hub Manager',
}
